import React from 'react'
import { MDBTable, MDBTableBody } from 'mdbreact';
import BotonesFormulario from '../componentes/BotonesFormulario'
import HeaderTabla from '../componentes/HeaderTabla'

const VerPaginas = ({ data, seleccionaRegistro }) => {
    return (
        <MDBTable hover responsive>
            <HeaderTabla array={['Id', 'Nombre', 'Url', 'Menu', '']} />
            <MDBTableBody>

                {data.map((item, index) => {
                    let menuString = item.menu == 'true' ? 'Si' : 'No'
                    return (
                        <tr key={index} className="tabla_productos">
                            <td>{item.id}</td>
                            <td>{item.nombre}</td>
                            <td>{item.url}</td>
                            <td>{menuString}</td>
                            <td className="tabla_funciones">
                                <BotonesFormulario SeleccionarCategoria={seleccionaRegistro} item={item} Roll={'Admin'} />
                            </td>
                        </tr>
                    )
                })}

            </MDBTableBody>
        </MDBTable>
    )
}

export default VerPaginas